import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AuthContext } from '../../../../context/AuthContext'
import ExpandedCardsSystem from '../../../expandedCardsSystem/ExpandedCardsSystem'
import CustomCircularProgress from '../../../smallComponents/CustomCircularProgress'
import TitleHeader from '../../../smallComponents/Header'
import MultiLangNumber from '../../../smallComponents/MultiLangNumber'
import ChannelRequestDetails from './ChannelRequestsComps/ChannelRequestDetails'

const ChannelRequests = ({ DCGProps, channel, members }) => {
  const { t } = useTranslation()
  const [requests, setRequests] = useState([])
  const [requestsUsers, setRequestsUsers] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const { user } = useContext(AuthContext)
  useEffect(() => {
    const fetchRequests = async () => {
      setIsLoading(true)
      try {
        const res = await axios.get(`/requests/elementRequests/${channel?._id}`)
        setRequests(res.data.requests)
        setRequestsUsers(res.data.requestsUsers)
      } catch (error) {
        console.log(error)
      }
      setIsLoading(false)
    }
    fetchRequests()
  }, [user?._id])
  return isLoading ? (
    <div>
      <CustomCircularProgress />
    </div>
  ) : (
    <>
      <TitleHeader
        headerText={`${MultiLangNumber(requests?.length)} ${t('Requests')}`}
      />
      <ExpandedCardsSystem
        cards={requests}
        UnitCardDetailsComponent={ChannelRequestDetails}
        firsButtonConfigs={{
          hideButton: true,
          props: {
            channel,
            members,
          },
        }}
        searchSystemProps={{}}
        DCGProps={DCGProps}
        requestsUsers={requestsUsers}
        setRequests={setRequests}
      />
    </>
  )
}

export default ChannelRequests
